import React, {useState, useEffect} from "react";
import UsersDataService from "../services/users";
import {Link, useParams} from "react-router-dom";

const User = props =>
{
    const initialUserState = {
        username: null,
        highscore: null,
        scores: [],
    };

    const[user, setUser] = useState(initialUserState);

    const getUser = username => {
        UsersDataService.get(username)
        .then(response => {
            setUser(response.data);
            console.log(response.data);
        })
        .catch(e => {
            console.error("Cannot load user with username " + username);
        });

    }

    let {username} = useParams();
    useEffect(() => {
        getUser(username);
    }, [username]);

    return (
        <div>
            <div style={{textAlign: "center"}}>
                <Link to = {"/"}><h3>Back to game</h3></Link>
                <h3>{username}</h3>
                <hr/>
                <h4>Performance:</h4>
                <ul className="list-group" style={{width: 200, display:"inline-block"}}>
                {user.scores.map((score, index) => {
                    const date_string = new Date(score.date).toLocaleString();
                    return(
                        <div className = "scores_entry" key = {score._id}>
                            <li className="list-group-item">Date: {date_string}<br/>Score: {score.score}</li>        
                        </div>
                    );
                })}
                </ul>
            </div>
        </div>
    );
}

export default User;